<div class="flex flex-col h-[22rem]">
    @if (failedFileValidation()) {
        <div class="flex flex-col space-y-1 mb-6">
            @for (error of fileValidationResult!.errors; track error) {
                <div class="flex flex-row space-x-5">
                    <mat-icon class="!text-xl !h-auto !min-w-5 !text-error-700">
                        error
                    </mat-icon>
                    <mat-error class="!text-sm !font-normal">{{
                        error.errorMessage
                    }}</mat-error>
                </div>
            }
        </div>
    }
    <mat-card
        class="!h-72 !border-2 !border-dashed !border-primary-700 !rounded-lg !bg-neutral-200 transition-colors duration-500 flex-grow"
        [ngClass]="{
            '!bg-primary-100': isDragOver,
        }"
        (dragover)="onDragOver($event)"
        (dragenter)="onDragEnter($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
    >
        <mat-card-content class="!h-full">
            <div
                class="flex flex-col gap-2 justify-center items-center text-center w-full h-full text-sm"
            >
                <div class="w-full h-auto">
                    <mat-icon
                        class="!text-5xl !w-full !h-auto !text-primary-800"
                    >
                        upload_file
                    </mat-icon>
                </div>
                <div class="w-full">Drag and Drop Files to Upload</div>
                <div class="w-full">or</div>
                <div class="w-full">
                    <input
                        #attachmentFileInput
                        type="file"
                        hidden
                        accept="{{ acceptedFileTypes }}"
                        (change)="onFileSelected($event)"
                    />
                    <button
                        mat-raised-button
                        color="primary"
                        class="w-5/12"
                        (click)="attachmentFileInput.click()"
                    >
                        Browse
                    </button>
                </div>
                <div class="text-tertiary-500">
                    Supported Files: PDF, Docx, Doc
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
